export default function PlatformAdvantages() {
  const advantages = [
    {
      icon: 'ri-scroll-to-bottom-line',
      title: '下拉式阅读',
      desc: '专为手机优化的下拉式漫画阅读体验，滑动即可畅读，告别翻页烦恼',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      desc: '每天都有最新韩国漫画更新，追更不等待，热门韩漫第一时间呈现',
    },
    {
      icon: 'ri-hd-line',
      title: '高清全彩',
      desc: '所有漫画均为高清全彩画质，完美还原韩漫原作的精美画风和细节',
    },
    {
      icon: 'ri-user-unfollow-line',
      title: '无需注册',
      desc: '打开网站即可免费阅读，无需注册账号，无需付费，纯粹阅读体验',
    },
  ];

  const stats = [
    { value: '30,000+', label: '漫画资源' },
    { value: '1,000万+', label: '月活用户' },
    { value: '每日上新', label: '持续更新' },
    { value: '99.8%', label: '用户好评' },
  ];

  return (
    <section className="py-14 md:py-20 bg-secondary-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-background-50 text-foreground-700 text-xs font-medium rounded-full mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择非麻瓜漫画
          </h2>
          <p className="mt-2 text-sm text-foreground-500">我们致力于打造最好的韩漫阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {advantages.map((item) => (
            <div key={item.title} className="text-center p-5">
              <span className="w-12 h-12 flex items-center justify-center mx-auto text-3xl text-primary-500">
                <i className={item.icon}></i>
              </span>
              <h3 className="mt-3 text-base font-heading font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-5">
              <p className="text-3xl md:text-4xl font-heading font-bold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-1 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}